import { useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../api/axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import MainLayout from "../layoutpage/MainLayout";
import { toast } from "react-toastify";
import { useMinimumPercent } from "../../utilities/MinimumPercentContext";
import Footer from "../../components/Footer";
import { clearIdempotencyKey, getIdempotencyKey } from "../../utilities/idempotencyKey";

export default function PaymentBookingPage({ user, onLogout }) {
  user = JSON.parse(localStorage.getItem("user"));
  const { state } = useLocation();
  const { bookingDetails, method } = state;
  console.log("booking details method", bookingDetails, method);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const submittingRef = useRef(false);
  const paymentKeyRef = useRef(null);

  const minimumPercent = localStorage.getItem("minimumPercent");

  console.log("minimumPercent in payment page", minimumPercent);

  // Document upload state for first payment
  const [photo, setPhoto] = useState(null);
  const [nid, setNid] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [nidPreview, setNidPreview] = useState(null);

  const { bookingId } = useParams();
  const navigate = useNavigate();

  const handleFileChange = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      if (type === "photo") {
        setPhoto(file);
        setPhotoPreview(URL.createObjectURL(file));
      } else {
        setNid(file);
        setNidPreview(URL.createObjectURL(file));
      }
    }
  };

  const handlePaymentSubmit = async () => {
    if (submittingRef.current) return;
    const minimum = (bookingDetails.unit.price * minimumPercent) / 100;
    const maximum = bookingDetails.unit.price;
    const dueAmount = bookingDetails.due_amount;
    console.log(
      "minimum<Number(amount)",
      minimum < Number(amount),
      "dueAmount===Number(amount)",
      dueAmount == Number(amount),
      "minimum",
      minimum,
      "dueAmount",
      dueAmount,
      "Number(amount)",
      Number(amount)
    );

    if (Number(amount) < minimum && !(dueAmount == Number(amount))) {
      setError(`Minimum payable amount is ৳${minimum}`);
      return;
    }
    if (Number(amount) > dueAmount) {
      setError(`You cannot pay more than due amount ৳${dueAmount}`);
      return;
    }
    if (Number(amount) > maximum) {
      setError(`You cannot pay more than total price ৳${maximum}`);
      return;
    }

    submittingRef.current = true;
    setSubmitting(true);

    // First payment document validation and upload
    if (Number(bookingDetails.paid_amount) === 0) {
      if (!photo || !nid) {
        setError(
          "Please upload both Photo and NID copy for the first payment."
        );
        submittingRef.current = false;
        setSubmitting(false);
        return;
      }

      try {
        const formData = new FormData();
        formData.append("photo", photo);
        formData.append("nid", nid);

        await api.post(`/api/bookings/${bookingId}/documents`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } catch (err) {
        console.log(err);
        setError("Failed to upload documents. Please try again.");
        submittingRef.current = false;
        setSubmitting(false);
        return;
      }
    }

    try {
      const requestIdentity = JSON.stringify({ bookingId, amount: Number(amount), payment_method: method });
      const idempotencyKey = getIdempotencyKey(paymentKeyRef, requestIdentity);
      const res = await api.post(`/api/bookings/${bookingId}/pay`, {
        amount: amount, //
        payment_method: method, //
      }, { headers: { "Idempotency-Key": idempotencyKey } });
      console.log("Report Data", res.data);
      setError("");
      toast.success("Payment report generated successfully!");
      generatePDF(res.data);
      // NEW → redirect to success page
      navigate(`/payment-success/${bookingId}`, {
        state: {
          booking: res.data,
          method,
          amount,
        },
      });
      clearIdempotencyKey(paymentKeyRef);
    } catch (err) {
      console.log(err);
      const message = err.response?.data?.message || "Payment could not be submitted. Retry the same amount to safely continue.";
      setError(message);
      toast.error(message);
    } finally {
      submittingRef.current = false;
      setSubmitting(false);
    }
  };

  const generatePDF = (booking) => {
    const pdf = new jsPDF("p", "mm", "a4");

    // Public logo URL
    const logoUrl =
      process.env.PUBLIC_URL + "/assets/images/reportPic/header1.png";
    pdf.addImage(logoUrl, "PNG", 15, 10, 180, 25);

    // Title
    pdf.setFontSize(22);
    pdf.setFont("helvetica", "bold");
    pdf.text("Payment Invoice", 105, 40, { align: "center" });

    // Booking Information Header
    pdf.setFillColor(0, 123, 255);
    pdf.rect(10, 50, 190, 12, "F");
    pdf.setTextColor(255);
    pdf.setFontSize(14);
    pdf.text("Booking Information", 15, 58);

    // Booking Info
    pdf.setFontSize(12);
    pdf.setTextColor(0);
    pdf.setFont("helvetica", "normal");
    pdf.text(`Customer: ${booking.booking.user.name}`, 15, 75);
    pdf.text(`Booking ID: ${booking.booking.id}`, 15, 85);
    pdf.text(`Unit: ${booking.booking.unit.unit_number}`, 15, 95);
    pdf.text(`Property: ${booking.booking.property.name}`, 15, 105);

    // Payment Details Header
    pdf.setFillColor(40, 167, 69);
    pdf.rect(10, 120, 190, 12, "F");
    pdf.setTextColor(255);
    pdf.setFontSize(14);
    pdf.text("Payment Details", 15, 128);

    // Payment Info
    pdf.setFontSize(12);
    pdf.setTextColor(0);
    pdf.text(`Payment Method: ${method}`, 15, 145);

    pdf.text(`Total Amount: ${booking.booking.total_amount} BDT`, 170, 155, {
      align: "right",
    });

    pdf.text(`Paid Amount: ${booking.booking.paid_amount} BDT`, 170, 165, {
      align: "right",
    });

    pdf.text(`Remaining Due: ${booking.booking.due_amount} BDT`, 170, 175, {
      align: "right",
    });

    // Footer
    // pdf.setFontSize(10);
    // pdf.setTextColor(100);
    // pdf.text(
    //   "This is a system-generated receipt from Iconic Project Property",
    //   105,
    //   275,
    //   { align: "center" }
    // );
    // bottom margin 10mm

    const footer =
      process.env.PUBLIC_URL + "/assets/images/reportPic/footer.png";

    //
    const footerImg = new Image();
    footerImg.src = footer;

    footerImg.onload = () => {
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const margin = 15;
      const maxWidth = pageWidth - margin * 2;

      const imgWidth = maxWidth;
      const imgHeight = (footerImg.height * imgWidth) / footerImg.width;

      const y = pageHeight - imgHeight - 10;

      pdf.addImage(footerImg, "PNG", margin, y, imgWidth, imgHeight);

      pdf.save(`payment_${booking.booking.id}.pdf`);
    };
  };

  return (
    <>
      <div
        className="container-fluid d-flex justify-content-center align-items-center"
        style={{
          minHeight: "100vh",
          paddingLeft: window.innerWidth > 768 ? "280px" : "15px",
        }}
      >
        {/* PAYMENT CARD */}
        <div
          className="shadow-lg rounded-4 p-4"
          style={{
            width: "100%",
            maxWidth: "550px",
            background: "rgba(255, 255, 255, 0.85)",
            backdropFilter: "blur(10px)",
            border: "1px solid #eee",
          }}
        >
          {/* Header */}
          <div
            className="p-4 rounded-4 mb-4 text-white"
            style={{
              background: "linear-gradient(135deg, #0d6efd, #6610f2)",
              boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
            }}
          >
            <h2 className="fw-bold mb-1">
              Payment for {bookingDetails.unit.unit_number}
            </h2>
            <p className="mb-0" style={{ opacity: 0.9 }}>
              Secure & Fast Payment
            </p>
          </div>

          {/* Payment Details Card */}
          <div
            id="pdf"
            className="p-4 rounded-4 mb-4"
            style={{
              background: "#f8f9fa",
              border: "1px solid #ddd",
            }}
          >
            <h5 className="fw-bold">Payment Summary</h5>

            <p className="mt-3 mb-2">
              <strong>Method:</strong>
              <span className="text-primary"> {method} </span>
            </p>

            <p className="mb-2">
              <strong>Total Price:</strong>
              <span className="text-success fw-bold">
                {" "}
                ৳ {bookingDetails.total_amount}
              </span>
            </p>
            {/* paid amount */}
            <p className="mb-2">
              <strong>Paid Amount:</strong>
              <span className="text-success fw-bold">
                {" "}
                ৳ {bookingDetails.paid_amount}
              </span>
            </p>
            {/* paid amount */}
            <p className="mb-2">
              <strong>Due Amount:</strong>
              <span className="text-danger fw-bold">
                {" "}
                ৳ {bookingDetails.due_amount}
              </span>
            </p>

            <p className="mb-2">
              <strong>Minimum Payable:</strong>
              <span className="text-success fw-bold">
                {" "}
                ৳ {bookingDetails.unit.price * 0.1}
              </span>
            </p>
          </div>

          {/* Document Upload for First Payment */}
          {Number(bookingDetails.paid_amount) === 0 && (
            <div className="mb-4 border p-3 rounded-3 bg-light">
              <h5 className="fw-bold mb-3">Upload Documents (Required)</h5>

              {/* Photo Upload */}
              <div className="mb-3">
                <label className="fw-semibold mb-1">Applicant Photo</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => handleFileChange(e, "photo")}
                />
                {photoPreview && (
                  <div className="mt-2">
                    <img
                      src={photoPreview}
                      alt="Preview"
                      style={{
                        height: "100px",
                        borderRadius: "5px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                )}
              </div>

              {/* NID Upload */}
              <div className="mb-3">
                <label className="fw-semibold mb-1">NID Copy</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*,application/pdf"
                  onChange={(e) => handleFileChange(e, "nid")}
                />
                {nidPreview && (
                  <div className="mt-2">
                    <img
                      src={nidPreview}
                      alt="Preview"
                      style={{
                        height: "100px",
                        borderRadius: "5px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Amount Input */}
          <div className="mb-3">
            <label className="fw-semibold mb-1">Enter Payment Amount</label>
            <input
              type="number"
              className="form-control form-control-lg rounded-3 shadow-sm"
              placeholder="Enter amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              style={{ fontSize: "18px" }}
            />
          </div>

          {/* Error */}
          {error && <p className="text-danger fw-semibold mb-3">{error}</p>}

          {/* Pay Now Button */}
          <button
            className="btn btn-success w-100 py-3 rounded-3 fw-bold"
            style={{
              fontSize: "18px",
              boxShadow: "0px 4px 10px rgba(0, 128, 0, 0.3)",
            }}
            onClick={handlePaymentSubmit}
            disabled={submitting}
          >
            {submitting ? "Submitting…" : "Pay Now"}
          </button>
        </div>
      </div>
    </>
  );
}
